/**
 * Extract a user-facing error message from an API error.
 *
 * @param {unknown} error - The error (usually an Axios error)
 * @param {string}  [fallback] - Optional fallback message
 * @returns {string}
 */
export function getErrorMessage(error, fallback = 'Ein Fehler ist aufgetreten') {
  if (!error) return fallback;

  // Axios error with backend message
  const serverMsg =
    error?.response?.data?.message ??
    error?.response?.data?.error;

  if (typeof serverMsg === 'string' && serverMsg.length > 0) {
    return serverMsg;
  }

  // Array of messages (NestJS class-validator)
  const messages = error?.response?.data?.message;
  if (Array.isArray(messages) && messages.length > 0) {
    return messages.join(', ');
  }

  // Standard JS error
  if (typeof error?.message === 'string' && error.message.length > 0) {
    return error.message;
  }

  return fallback;
}
